import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#E0E0E0",
    "col1n": "#FFFFFF",
    "col1s": "#C2C2C2"
}
function ObjMor109({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill="#E0E0E0"
                    d="M121.65 308.4l.1-.15q-.057.065-.15.1l.05.05z"
                    id="ObjMor109__Layer9_0_FILL"
                />
                <path
                    fill={colors.col1n}
                    d="M62.45 33.4L53.5 0 0 14.3l3.1 11.55q1.45.2 3 .7 2.25 1 3.95 3 0 .05.05.1.15.15.3.35 2.85 4.4 2.35 9.9-.1.75-.25 1.5v.05l-.1.5q-.4 1.55-.95 2.75-.7 1.4-1.65 2.35l-.7.6-.1.1L62.45 33.4z"
                    id="ObjMor109__Symbol_282_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M0 22.85l15.3-19.5-1.15-.4L1.05 19.6l-.1.5q-.4 1.55-.95 2.75m51-11.3l-.3-1.05L25.1 0l-.8.9L51 11.55z"
                    id="ObjMor109__Symbol_284_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1s}
                    d="M53.8 1.3L53.5 0 34.8 22.35q-1.15 1.3-2.5 1.85-.4.2-.8.3-.5.1-1.05.2-1.4.1-3.05-.4L0 14.3l.35 1.25 27.4 9.95q1.65.55 3.05.45.5-.05.95-.15.45-.1.9-.35 1.35-.65 2.5-1.85L53.8 1.3z"
                    id="ObjMor109__Symbol_283_0_Layer0_0_FILL"
                />
            </defs>
            <use xlinkHref="#ObjMor109__Layer9_0_FILL" />
            <use
                xlinkHref="#ObjMor109__Symbol_282_0_Layer0_0_FILL"
                transform="translate(112.65 260.65)"
                id="ObjMor109__col1n"
            />
            <use
                xlinkHref="#ObjMor109__Symbol_284_0_Layer0_0_FILL"
                transform="translate(124.1 282.5)"
                id="ObjMor109__col1d"
            />
            <use
                xlinkHref="#ObjMor109__Symbol_283_0_Layer0_0_FILL"
                transform="translate(112.65 260.65)"
                id="ObjMor109__col1s"
            />
        </g></g>
    )
}
export default ObjMor109
